import { useContext } from 'react';

import { OrgUnitOmeMeetEntryStateContext } from './OrgUnitOmeMeetEntryContextProvider';
import OrgUnitOmeMeetEntryData from './OrgUnitOmeMeetEntryData';

const useOrgUnitOmeMeetEntryData = () => {
  const [orgUnitOmeMeetEntryState, setOrgUnitOmeMeetEntryState] = useContext(OrgUnitOmeMeetEntryStateContext);

  const getOrgUnitsByOmeMeetIdAndOmeMeetEntryId = (omeMeetId, omeMeetEntryId) => OrgUnitOmeMeetEntryData.getOrgUnitsByOmeMeetIdAndOmeMeetEntryIdData(omeMeetId, omeMeetEntryId, orgUnitOmeMeetEntryState, setOrgUnitOmeMeetEntryState);

  return {
    orgUnitOmeMeetEntryState,
    getOrgUnitsByOmeMeetIdAndOmeMeetEntryId
  };
};

export default useOrgUnitOmeMeetEntryData;